import types from './types';

export default {
  [types.getters.GET_ROOMS]: (state) => () => {
    return state.rooms
  },
  [types.getters.GET_ROOM_BY_ID]: (state) => (roomId) => {
    if (state.rooms) {
      return state.rooms.find((r) => r.id === Number(roomId))
    } else {
      return undefined
    }
  },
  [types.getters.GET_ROOM_BY_POSITION]: (state) => (roomPosition) => {
    if (state.rooms) {
      return state.rooms.find((r) => r.position === Number(roomPosition))
    } else {
      return undefined
    }
  },
  [types.getters.HAS_ROOMS]: (state) => () => {
    return !!state.rooms;
  },
  [types.getters.IS_FETCHING]: (state) => () => {
    return state.fetch.status === 'pending';
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/room/getters.js